import { fakeModel } from "../model"

function lastUser(prompt: Parameters<Parameters<typeof fakeModel>[0]>[0]) {
  const message = [...prompt].reverse().find(m => m.role === "user")
  if (!message || typeof message.content === "string") return ""
  return message.content.map(p => p.type === "text" ? p.text : "").join("")
}

// Always the same edit: an item at the end of main that says what the author wrote, then a line about how it went
export const fakeDesigner = fakeModel(prompt => {
  const last = prompt[prompt.length - 1]
  if (last.role === "tool") {
    const result = last.content[0]?.result as { issues?: PlaybookIssue[], error?: string } | undefined
    if (result?.error) return { text: `The edit failed: ${result.error}` }
    return { text: `Added an item at the end of main. The validator reports ${result?.issues?.length ?? 0} issues.` }
  }
  const message = lastUser(prompt)
  const id = `fake_${Date.now().toString(36)}`
  return {
    thinking: `The author wrote "${message}". The fake designer does not understand it: it always adds an item to the end of main that says it, with one option to go on.`,
    calls: [{ name: "put_item", args: { flow: "main", item: { id, title: message.slice(0, 40), intent: "Added by the fake designer", say: message, options: [{ label: "OK" }] } } }],
  }
})
